module.exports = __webpack_public_path__ + "img/bg1.b3f24c76.jpg";